module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_maedori-1526b20aff77c1ad313ce3f720788ea3.webp";